import React from 'react';

function Referrals(props) {
  return (
    <div>
      <h2>We Recommend:</h2>
      <h3>This guy's work is stellar.  He goes to you and details your car.  Like NEW.  Michael Micheal Lopez ! My whole family uses him and he works HARD! ❤️
        Professional Interior, Exterior Detailing, Specializing in Paint Correction, Ceramic Coating 928-243-6616
      </h3>
      <h3>I just cleaned a big house and NOT ONE BUG. Heals Pest Control was her exterminator! Call Chris Heal if you need a bug guy!</h3>
      <h3>LOOKING FOR A COMMERCIAL PROPERTY MANAGER? Contact Bridget Wood 928-242-2162 Bridget@MTNRetreatRealty.com</h3>
    </div>
  );
}

export default Referrals;
